var React = require('react');

function IconPlusXs (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon XS"},React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M6 0.257812C5.44772 0.257812 5 0.705528 5 1.25781V5.25781H1C0.447715 5.25781 0 5.70553 0 6.25781C0 6.8101 0.447715 7.25781 1 7.25781H5V11.2578C5 11.8101 5.44772 12.2578 6 12.2578C6.55228 12.2578 7 11.8101 7 11.2578V7.25781H11C11.5523 7.25781 12 6.8101 12 6.25781C12 5.70553 11.5523 5.25781 11 5.25781H7V1.25781C7 0.705528 6.55228 0.257812 6 0.257812Z","fill":"#001D3B"})));
}

IconPlusXs.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = IconPlusXs;

IconPlusXs.default = IconPlusXs;
